import React from 'react';
import PropTypes from 'prop-types';

import pageNames from '../pages/pageNames';
import { DISABILITY_526_V2_ROOT_URL } from '../../constants';

const FileClaimComponent = ({
  onFileClaimClick = () => {},
  onLearnMoreClick = () => {},
}) => {
  return (
    <div id={pageNames.fileClaim} className="vads-u-margin-top--3">
      <p className="vads-u-margin-top--0">
        Based on your responses, you should file for disability compensation
        with VA Form 21-526EZ.
      </p>
      <va-link-action
        href={`${DISABILITY_526_V2_ROOT_URL}/introduction`}
        onClick={onFileClaimClick}
        text="File a disability claim online"
        type="primary"
      />
      <p>
        If you want to prepare to file your claim, you can learn more about VA
        Form 21-526EZ.
      </p>
      <p id="other_ways_to_file_526" className="vads-u-margin-bottom--0">
        <va-link
          external
          href="/disability/how-to-file-claim/"
          text="Learn more about filing a disability claim"
          onClick={onLearnMoreClick}
        />
      </p>
    </div>
  );
};

FileClaimComponent.propTypes = {
  onFileClaimClick: PropTypes.func,
  onLearnMoreClick: PropTypes.func,
};

export default FileClaimComponent;
